import { CUSTOMER_JOURNEY_SERVICES, CUSTOMER_JOURNEY_SERVICES_SUCCESS, CUSTOMER_JOURNEY_SERVICES_ERROR } from './../../actions/const';
import { CUSTOMER_JOURNEY_SERVICES_BOOK, CUSTOMER_JOURNEY_SERVICES_BOOK_SUCCESS, CUSTOMER_JOURNEY_SERVICES_BOOK_ERROR } from './../../actions/const';
import { SET_TOKEN, SET_LANG } from './../../actions/const';

import defer from 'lodash/defer';
import find from 'lodash/find';
import forEach from 'lodash/forEach';

import CustomerJourneySource from './../../sources/CustomerJourneySource';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  apiData: [],
  loading: false,
  bookingLoading: false,
  catId: null
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case CUSTOMER_JOURNEY_SERVICES: {
      nextState.loading = true;
      nextState.apiData = [];
      nextState.catId = action.catId;
      CustomerJourneySource.services(action.catId, action.token, action.lang, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_SERVICES_SUCCESS: {
      nextState.loading = false;
      nextState.apiData = action.data;
      return nextState;
    }
    case CUSTOMER_JOURNEY_SERVICES_ERROR: {
      nextState.loading = false;
      nextState.apiData = [];
      return nextState;
    }

    case CUSTOMER_JOURNEY_SERVICES_BOOK: {
      nextState.bookingLoading = true;
      CustomerJourneySource.servicesBook(action.serviceId, action.token, action.lang, action.successCallback, action.errorCallback);
      return nextState;
    }
    case CUSTOMER_JOURNEY_SERVICES_BOOK_SUCCESS: {
      nextState.bookingLoading = false;

      forEach(action.data, (newStatus, serviceId) => {
        let service = find(nextState.apiData, {id: serviceId});
        if(service) service.status = newStatus;
      });
      
      if(action.successCallback) defer(action.successCallback, action.data);
      return nextState;
    }
    case CUSTOMER_JOURNEY_SERVICES_BOOK_ERROR: {
      nextState.bookingLoading = false;
      if(action.errorCallback) defer(action.errorCallback);
      return nextState;
    }
    //case SET_TOKEN: // Since we need to do login from service modal we cannot trigger reload or we lose modal
    case SET_LANG: {
      if(!isEmpty(state.apiData)) {
        nextState.loading = true;
        nextState.apiData = [];
        CustomerJourneySource.services(nextState.catId, action.token, action.lang, action.context);
        return nextState;
      }
      else {
        return state;
      }
    }

    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/services.js